export enum ReferenciaImagemMarketplace {
    "logo" = "logo",
    "capa" = "capa"
}